import React from "react";
import { Link } from "react-router-dom";

import ResumeDownload from "../Downloads/ResumeButton";
import WorkPresentationDownload from "../Downloads/WorkPresentationButton";

import ContactIcons from "../Contact/ContactIcons";

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${process.env.PUBLIC_URL}/pfp.jpg`} alt="Aryan D Sheth" />
      </Link>
      <header>
        <h2>Aryan&nbsp;Sheth</h2>
        <p>
          <a href="">aryandsheth.com</a>
        </p>
      </header>
      <div className="downloads">
        <ResumeDownload />
        <WorkPresentationDownload />
      </div>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I’m Aryan Deven Sheth—a Data Analyst, Data Engineer, and lifelong
        problem solver. With a passion for unlocking insights from complex data,
        I’ve built a career around making information actionable and impactful.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes("/resume") ? (
            <Link to="/resume" className="button">
              Learn&nbsp;More
            </Link>
          ) : (
            <Link to="/" className="button">
              About&nbsp;Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy;&nbsp;Aryan&nbsp;Sheth <Link to="/">aryandsheth.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
